// src/components/Currency.jsx
import React from "react";
import { useCurrency } from "../context/CurrencyContext";

const Currency = ({ amount = 0, className = "" }) => {
  const { format } = useCurrency();
  return <span className={className}>{format(amount)}</span>;
};

export default Currency;